import React from 'react';
import moment from 'moment';
import { Paper, Grid } from '@material-ui/core';
import { DialWidgetCard } from '../../Elements';
import BlrProjection from './BlrProjection';
import { displayDateFormatShort } from '../../../constants';

const BvFbvOutput = ({ logResult }) => {
  const hasFuture = logResult.future_blr_value && Object.keys(logResult.future_blr_value).length;

  return (
    <div className="bv-fbv-output engine-valuation-output">
      {hasFuture ? (
        <Paper className="output-fbv-card engine-projection-header">
          <div>
            <h4>Future Projection Values</h4>
            <p>Projection Till: <span>{moment(logResult.projection_to).format(displayDateFormatShort)}</span></p>
          </div>
          <div className="engine-output-actions">
            <BlrProjection logResult={logResult} />
          </div>
        </Paper>
      ) : null}

      <p className="engine-value-as-of">Value as of: {moment(logResult.base_value_date).format(displayDateFormatShort)}</p>

      <Paper className="output-widget-card engine-result-card">
        <Grid container spacing={1}>
          <Grid item md={12} xs={12}>
            <DialWidgetCard value={logResult.blr_value ? logResult.blr_value : null} label="Base Lease Rate" unit="k" />
          </Grid>
        </Grid>
        <h4 className="engine-card-caption">Base Lease Rate</h4>
      </Paper>

      <Paper className="output-widget-card engine-result-card">
        <Grid container spacing={1}>
          <Grid item md={12} xs={12}>
            <DialWidgetCard value={logResult.mlr_value ? logResult.mlr_value : null} label="Market Lease Rate" unit="k" />
          </Grid>
        </Grid>
        <h4 className="engine-card-caption">Market Lease Rate</h4>
      </Paper>
    </div>
  );
};

export default BvFbvOutput;
